export default "__VITE_ASSET__WAVm0jsz__"